import React from "react"
import PropTypes from "prop-types"
import cx from "classnames"
import s from "./Sidebar.module.scss"

/**
 * Logo + gradient wordmark band at the top of the sidebar.
 * Split out so the sidebar stays layout-only and the brand can be swapped
 * per deployment without touching navigation code.
 */
const SidebarBrand = ({ logoSrc, wordmark = "AVDHAAN", collapsed = false, onClick, className }) => {
  const content = (
    <>
      {logoSrc && <img src={logoSrc} alt="" className={s.logo} aria-hidden="true" />}
      <h1 className={s.wordmark}>{wordmark}</h1>
    </>
  )

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        aria-label={`${wordmark} home`}
        className={cx(s.brand, { [s.collapsed]: collapsed }, className)}
        style={{ border: 0, cursor: "pointer", width: "100%" }}
      >
        {content}
      </button>
    )
  }

  return <div className={cx(s.brand, { [s.collapsed]: collapsed }, className)}>{content}</div>
}

SidebarBrand.propTypes = {
  logoSrc: PropTypes.string,
  wordmark: PropTypes.string,
  collapsed: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string
}

export default SidebarBrand
